(function () {
  function normalize(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function esc(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function escAttr(value) {
    return esc(value).replace(/'/g, "&#39;");
  }

  function highlight(value, query) {
    var safe = esc(value);
    if (!query) return safe;
    var re = new RegExp(
      "(" + query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")",
      "gi",
    );
    return safe.replace(re, "<mark>$1</mark>");
  }

  function initSkuLookup(root) {
    if (!root || root.dataset.skuLookupInitialized === "true") return;

    var sid = root.dataset.sectionId;
    var dataEl = document.getElementById("gsc-sku-data-" + sid);
    var searchEl = document.getElementById("gsc-sku-search-" + sid);
    var clearEl = document.getElementById("gsc-sku-clear-" + sid);
    var typeEl = document.getElementById("gsc-sku-type-" + sid);
    var inStockEl = document.getElementById("gsc-sku-in-stock-" + sid);
    var outStockEl = document.getElementById("gsc-sku-out-stock-" + sid);
    var listEl = document.getElementById("gsc-sku-list-" + sid);
    var statsEl = document.getElementById("gsc-sku-stats-" + sid);
    var snapshotEl = document.getElementById("gsc-sku-snapshot-" + sid);
    var emptyEl = document.getElementById("gsc-sku-empty-" + sid);
    var paginationEl = document.getElementById("gsc-sku-pagination-" + sid);
    var prevEl = document.getElementById("gsc-sku-prev-" + sid);
    var nextEl = document.getElementById("gsc-sku-next-" + sid);
    var pageStatusEl = document.getElementById("gsc-sku-page-status-" + sid);
    var filtersDisclosureEl = root.querySelector(
      ".gsc-sku__filters-disclosure",
    );

    if (
      !sid ||
      !dataEl ||
      !searchEl ||
      !clearEl ||
      !typeEl ||
      !inStockEl ||
      !outStockEl ||
      !listEl ||
      !statsEl ||
      !snapshotEl ||
      !emptyEl ||
      !paginationEl ||
      !prevEl ||
      !nextEl ||
      !pageStatusEl ||
      !filtersDisclosureEl
    )
      return;

    root.dataset.skuLookupInitialized = "true";

    var mobileFiltersQuery = window.matchMedia("(max-width: 860px)");

    function syncFiltersDisclosure(event) {
      filtersDisclosureEl.open = !event.matches;
    }

    syncFiltersDisclosure(mobileFiltersQuery);
    if (mobileFiltersQuery.addEventListener) {
      mobileFiltersQuery.addEventListener("change", syncFiltersDisclosure);
    } else {
      mobileFiltersQuery.addListener(syncFiltersDisclosure);
    }

    var totalPages = parseInt(
      dataEl.getAttribute("data-total-pages") || "1",
      10,
    );
    var currentPage = parseInt(dataEl.getAttribute("data-page") || "1", 10);
    var pageSize = parseInt(root.dataset.rowsPerPage || "25", 10) || 25;
    var resultPage = 1;
    var rows = [];

    try {
      rows = JSON.parse(dataEl.textContent || "[]");
    } catch (error) {
      listEl.innerHTML =
        '<div class="gsc-sku__empty">SKU index could not be loaded.</div>';
      return;
    }

    setSnapshotTime();

    function fetchPage(page, callback) {
      var url =
        window.location.pathname +
        "?sections=" +
        encodeURIComponent(String(sid)) +
        "&page=" +
        page;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        if (xhr.status !== 200)
          return callback(new Error("HTTP " + xhr.status));

        try {
          var response = JSON.parse(xhr.responseText);
          var html = response[String(sid)] || "";
          var match = html.match(
            /id=["']gsc-sku-data-[^"']*["'][^>]*>([\s\S]*?)<\/script>/,
          );
          if (!match) return callback(new Error("data block not found"));
          callback(null, JSON.parse(match[1]));
        } catch (error) {
          callback(error);
        }
      };
      xhr.onerror = function () {
        callback(new Error("network error"));
      };
      xhr.send();
    }

    function formatSnapshotDate(date) {
      try {
        return new Intl.DateTimeFormat(undefined, {
          month: "short",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "2-digit",
        }).format(date);
      } catch (error) {
        return date.toLocaleString();
      }
    }

    function setSnapshotTime() {
      var snapshotText = formatSnapshotDate(new Date());
      snapshotEl.textContent =
        "Inventory shown as of " +
        snapshotText +
        " (EST) and subject to change. Product pages may show newer availability.";
      snapshotEl.setAttribute(
        "aria-label",
        "Inventory shown as of " +
          snapshotText +
          ". Product pages may show newer availability.",
      );
    }

    function sortRows(items) {
      items.sort(function (a, b) {
        var ac = normalize(a.coreSku);
        var bc = normalize(b.coreSku);
        if (ac !== bc) return ac.localeCompare(bc);
        return normalize(a.productTitle).localeCompare(
          normalize(b.productTitle),
        );
      });
    }

    function optionList(field) {
      var values = {};
      rows.forEach(function (row) {
        var value = row[field] || "";
        if (value) values[value] = true;
      });
      return Object.keys(values).sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
    }

    function populateSelect(select, values) {
      values.forEach(function (value) {
        var option = document.createElement("option");
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
    }

    function matchesPartial(row, query) {
      if (!query) return true;
      var tagText = Array.isArray(row.tags) ? row.tags.join(" ") : "";
      if (
        normalize(row.coreSku).indexOf(query) !== -1 ||
        normalize(row.productTitle).indexOf(query) !== -1 ||
        normalize(row.productType).indexOf(query) !== -1 ||
        normalize(tagText).indexOf(query) !== -1
      )
        return true;
      if (Array.isArray(row.variants)) {
        for (var i = 0; i < row.variants.length; i++) {
          if (normalize(row.variants[i].sku).indexOf(query) !== -1) return true;
        }
      }
      return false;
    }

    function exactRows(query) {
      if (!query) return null;
      var matches = rows.filter(function (row) {
        if (normalize(row.coreSku) === query) return true;
        if (Array.isArray(row.variants)) {
          return row.variants.some(function (variant) {
            return normalize(variant.sku) === query;
          });
        }
        return false;
      });
      if (matches.length > 0) return { rows: matches };
      return null;
    }

    function rowLabel(row) {
      var title = String(row.productTitle || "Product").trim() || "Product";
      var sku = String(row.coreSku || "").trim();
      return sku ? "View " + title + ", Core SKU " + sku : "View " + title;
    }

    function variantStockText(variant) {
      if (!variant || !variant.tracked || typeof variant.stockQty !== "number")
        return "—";
      return variant.stockQty > 0
        ? "In stock (" + variant.stockQty + ")"
        : "Out of stock (0)";
    }

    function variantRowHtml(variant, query, productUrl) {
      var tracked = variant.tracked && typeof variant.stockQty === "number";
      var variantUrl = variant.url || productUrl;
      var stateClass = tracked
        ? variant.stockQty > 0
          ? " gsc-sku__variant-row--in-stock"
          : " gsc-sku__variant-row--out-of-stock"
        : "";
      var title = String(variant.title || "").trim();
      return (
        '<div class="gsc-sku__variant-row' +
        stateClass +
        '" role="link" tabindex="0" data-url="' +
        escAttr(variantUrl) +
        '" aria-label="' +
        escAttr("View product for variant SKU " + (variant.sku || "")) +
        '">' +
        '<span class="gsc-sku__variant-sku gsc-sku__mono" data-label="Variant SKU">' +
        highlight(variant.sku || "—", query) +
        "</span>" +
        '<span class="gsc-sku__variant-title" data-label="Variant">' +
        highlight(title, query) +
        "</span>" +
        '<span class="gsc-sku__variant-stock" data-label="Stock">' +
        esc(variantStockText(variant)) +
        "</span>" +
        "</div>"
      );
    }

    function rowHtml(row, query, isExact) {
      var stockQty = row.stockQty;
      var stockLabel =
        typeof stockQty === "number" ? String(Math.max(0, stockQty)) : "-";
      var stockClass =
        typeof stockQty === "number"
          ? stockQty > 0
            ? " gsc-sku__row--in-stock"
            : " gsc-sku__row--out-of-stock"
          : "";
      var productRow = (
        '<div class="gsc-sku__row' +
        stockClass +
        (isExact ? " gsc-sku__exact" : "") +
        '" role="link" tabindex="0" data-url="' +
        escAttr(row.productUrl) +
        '" aria-label="' +
        escAttr(rowLabel(row)) +
        '">' +
        '<span class="gsc-sku-row__item gsc-sku__mono" data-label="Core SKU">' +
        highlight(row.coreSku || "-", query) +
        "</span>" +
        '<span class="gsc-sku-row__item gsc-sku__product" data-label="Product">' +
        highlight(row.productTitle, query) +
        "</span>" +
        '<span class="gsc-sku-row__item gsc-sku__price" data-label="Price">' +
        esc(row.priceText || "-") +
        "</span>" +
        '<span class="gsc-sku-row__item gsc-sku__type" data-label="Type">' +
        highlight(row.productType || "-", query) +
        "</span>" +
        '<span class="gsc-sku-row__item last gsc-sku__stock" data-label="Stock Qty">' +
        esc(stockLabel) +
        "</span>" +
        "</div>"
      );
      var variantRows = Array.isArray(row.variants) && row.variants.length > 1
        ? row.variants
            .map(function (variant) {
              return variantRowHtml(variant, query, row.productUrl);
            })
            .join("")
        : "";
      return productRow + variantRows;
    }

    function matchesStock(row) {
      var showInStock = inStockEl.checked;
      var showOutStock = outStockEl.checked;
      var stockQty = row.stockQty;

      if (typeof stockQty !== "number") return showInStock && showOutStock;
      if (stockQty > 0) return showInStock;
      return showOutStock;
    }

    function closestRow(target) {
      if (!target || !target.closest) return null;
      return target.closest(".gsc-sku__row, .gsc-sku__variant-row");
    }

    function navigateRow(row) {
      var url = row && row.getAttribute("data-url");
      if (url) window.location.href = url;
    }

    function filteredRows(query, typeValue, exact) {
      var source = exact ? exact.rows : rows;
      return source.filter(function (row) {
        if (typeValue && row.productType !== typeValue) return false;
        if (!matchesStock(row)) return false;
        if (!exact && !matchesPartial(row, query)) return false;
        return true;
      });
    }

    function render(filtered, query, exact) {
      if (filtered.length === 0) {
        listEl.innerHTML = "";
        emptyEl.hidden = false;
        paginationEl.hidden = true;
        statsEl.textContent = "0 SKUs found";
        return;
      }

      emptyEl.hidden = true;
      var pageCount = Math.max(1, Math.ceil(filtered.length / pageSize));
      if (resultPage > pageCount) resultPage = pageCount;
      var start = (resultPage - 1) * pageSize;
      var visibleRows = filtered.slice(start, start + pageSize);
      var label = filtered.length === 1 ? "product" : "products";

      if (exact) {
        statsEl.textContent = filtered.length + " exact SKU " + label;
      } else if (
        query ||
        typeEl.value ||
        !inStockEl.checked ||
        !outStockEl.checked
      ) {
        statsEl.textContent =
          filtered.length + " of " + rows.length + " " + label + " shown";
      } else {
        statsEl.textContent = rows.length + " core SKU products indexed";
      }

      listEl.innerHTML = visibleRows
        .map(function (row) {
          return rowHtml(row, query, Boolean(exact));
        })
        .join("");

      paginationEl.hidden = pageCount <= 1;
      prevEl.disabled = resultPage <= 1;
      nextEl.disabled = resultPage >= pageCount;
      pageStatusEl.textContent = "Page " + resultPage + " of " + pageCount;
    }

    function renderCurrent() {
      var rawQuery = searchEl.value;
      var query = normalize(rawQuery);
      var typeValue = typeEl.value;
      var exact = exactRows(query);
      render(filteredRows(query, typeValue, exact), query, exact);
    }

    function applyFilters() {
      resultPage = 1;
      clearEl.style.display = searchEl.value.length ? "block" : "none";
      renderCurrent();
    }

    function init() {
      sortRows(rows);
      populateSelect(typeEl, optionList("productType"));
      applyFilters();
    }

    var timer;
    searchEl.addEventListener("input", function () {
      clearTimeout(timer);
      timer = setTimeout(applyFilters, 100);
    });
    clearEl.addEventListener("click", function () {
      searchEl.value = "";
      applyFilters();
      searchEl.focus();
    });
    typeEl.addEventListener("change", applyFilters);
    inStockEl.addEventListener("change", applyFilters);
    outStockEl.addEventListener("change", applyFilters);
    listEl.addEventListener("click", function (event) {
      var row = closestRow(event.target);
      if (!row || !listEl.contains(row)) return;
      navigateRow(row);
    });
    listEl.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      var row = closestRow(event.target);
      if (!row || event.target !== row || !listEl.contains(row)) return;
      event.preventDefault();
      navigateRow(row);
    });
    prevEl.addEventListener("click", function () {
      if (resultPage <= 1) return;
      resultPage -= 1;
      renderCurrent();
    });
    nextEl.addEventListener("click", function () {
      resultPage += 1;
      renderCurrent();
    });

    if (totalPages <= 1 || currentPage > 1) {
      init();
      return;
    }

    statsEl.textContent = "Loading all core SKU products...";
    var pending = totalPages - 1;
    for (var page = 2; page <= totalPages; page++) {
      (function (pageNumber) {
        fetchPage(pageNumber, function (error, data) {
          if (!error && Array.isArray(data)) {
            rows = rows.concat(data);
          }
          pending -= 1;
          if (pending === 0) init();
        });
      })(page);
    }
  }

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    if (scope.matches && scope.matches("[data-sku-lookup]")) {
      initSkuLookup(scope);
    }
    scope.querySelectorAll("[data-sku-lookup]").forEach(initSkuLookup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
